import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './styles/AboutVisionAI.css';

// Importamos o novo dicionário
import aboutTranslations from './dictionary/translateAboutVisionAI';

function AboutVisionAI() {
  const navigate = useNavigate();
  const location = useLocation();

  // 1) Captura a linguagem
  const { selectedLanguage } = location.state || { selectedLanguage: 'en' };

  // 2) Pega o dicionário correspondente ao idioma
  const t = aboutTranslations[selectedLanguage] || aboutTranslations.en;

  // 3) Controle de áudio
  const audioRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.play().catch((err) => {
        console.error('Falha ao tocar o áudio automaticamente:', err);
      });
    }
  }, []);

  const toggleMuteState = () => {
    setIsMuted(!isMuted);
    if (audioRef.current) {
      if (!isMuted) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      } else {
        audioRef.current.play().catch((err) => {
          console.error('Falha ao tocar o áudio:', err);
        });
      }
    }
  };

  return (
    <>
      {/* Ícone de volume acima do conteúdo */}
      <div
        className="volume-icon"
        onClick={toggleMuteState}
        style={{ cursor: 'pointer', textAlign: 'center', marginBottom: '10px' }}
      >
        <i
          className={`fas ${isMuted ? 'fa-volume-mute' : 'fa-volume-up'}`}
          style={{ fontSize: '24px', color: 'white' }}
        ></i>
      </div>

      {/* Áudio (invisível) */}
      <audio ref={audioRef} style={{ display: 'none' }} loop>
        <source
          src={process.env.REACT_APP_VISION_AI_STREAM_AUDIO_PATH}
          type="audio/mpeg"
        />
        Your browser does not support the audio element.
      </audio>

      <div className="about-container">
        <h2>{t.title}</h2>
        <p>{t.description1}</p>

        <h3>{t.mainFeaturesTitle}</h3>
        <ul>
          <li>🎙️ <strong>{t.transcription}</strong> {t.transcriptionDetail}</li>
          <li>🌎 <strong>{t.dubbingAI}</strong> {t.dubbingAIDetail}</li>
          <li>✂️ <strong>{t.intelligentCut}</strong> {t.intelligentCutDetail}</li>
          <li>📌 <strong>{t.lipSync}</strong> {t.lipSyncDetail}</li>
          <li>💄 <strong>{t.lipEnhance}</strong> {t.lipEnhanceDetail}</li>
          <li>🗂️ <strong>{t.videoMerge}</strong> {t.videoMergeDetail}</li>
          <li>⚡ <strong>{t.realTimeProcess}</strong> {t.realTimeProcessDetail}</li>
        </ul>

        <h3>{t.plansTitle}</h3>
        <p>{t.choosePlan}</p>
        <ul>
          <li><strong>{t.visionFree}</strong> {t.visionFreeDetail}</li>
          <li><strong>{t.visionStarter}</strong> {t.visionStarterDetail}</li>
          <li><strong>{t.visionGrowth}</strong> {t.visionGrowthDetail}</li>
          <li><strong>{t.visionPremium}</strong> {t.visionPremiumDetail}</li>
        </ul>

        <h3>{t.seeInAction}</h3>
        <iframe
          className="about-video"
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/Vvbxjm_yZoI"
          title="Vision AI Stream Demo"
          frameBorder="0"
          allowFullScreen
        ></iframe>

        <p>
          {t.officialChannel} <a href="https://www.youtube.com/@VisionAIStream" target="_blank" rel="noopener noreferrer">{t.officialChannelLink}</a>.
        </p>

        <h3>{t.faqTitle}</h3>

        <details>
          <summary>{t.faqQuestion1}</summary>
          <p>{t.faqAnswer1}</p>
        </details>

        <details>
          <summary>{t.faqQuestion2}</summary>
          <p>{t.faqAnswer2}</p>
        </details>

        <details>
          <summary>{t.faqQuestion3}</summary>
          <p>{t.faqAnswer3}</p>
        </details>

        <h3>{t.userFeedbackTitle}</h3>
        <p>{t.userFeedbackDetail}</p>

        {/* Botão para voltar para a Home */}
        <button className="cta-button" onClick={() => navigate('/')}>
          {t.backHomeButton}
        </button>

        <h3>{t.aboutCompanyTitle}</h3>
        <p>{t.companyDescription}</p>
      </div>
    </>
  );
}

export default AboutVisionAI;
